import React, { useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { useDispatch, useSelector } from 'react-redux'
import { setFilterFromDate } from '@app/actions/events'
import { dateErrors } from '@app/lib/Events/filters'
import { format } from 'date-fns'
import useStyles from './FilterFromDate.style'

const FilterFromDate = (): Node => {
  const dispatch = useDispatch()
  const { classes } = useStyles()
  const { filterFromDate } = useSelector((state) => state.events)
  const [selectedDate, setSelectedDate] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!filterFromDate) {
      setSelectedDate(null)
    }
  }, [filterFromDate])

  useEffect(() => {
    if (selectedDate) {
      if (selectedDate.toString() !== 'Invalid Date' && !dateErrors.includes(error)) {
        dispatch(setFilterFromDate(selectedDate))
      }
    }
  }, [error])

  const handleValidationError = (err, value) => {
    setError(err)
    setSelectedDate(value)
  }

  const handleDateChange = (date) => {
    if (!date) {
      setSelectedDate(null)
      dispatch(setFilterFromDate(''))
      return
    }

    const formattedDate = format(date, 'yyyy-MM-dd')
    setSelectedDate(formattedDate)
    dispatch(setFilterFromDate(formattedDate))
  }

  return (
    <div className={classes.container}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Typography className={classes.title}>
          {I18n.t('my_events.filter_by_date')}
        </Typography>
        <Typography className={classes.label}>
          {I18n.t('my_events.from')}
        </Typography>
        <DatePicker
          format="dd/MM/yyyy"
          value={selectedDate ? new Date(selectedDate) : null}
          onChange={handleDateChange}
          onError={(err, val) => handleValidationError(err, val)}
          slotProps={{
            textField: {
              variant: 'standard',
              className: classes.datePicker,
            },
          }}
        />
      </LocalizationProvider>
    </div>
  )
}

export default FilterFromDate
